const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/ideas/view/$viewId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
export const ideaSchema = z.object({
  ideaId: z.number().optional(),
  filter: z.enum(['active', 'stale', 'archived']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/intake/ideas/view/$viewId/')({
  validateSearch: search => ideaSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.ideaManagement.general.ideas.label)
    }
  }
});